document.addEventListener('DOMContentLoaded', function() {
    if ('scrollRestoration' in history) {
        history.scrollRestoration = 'manual';
    }
    window.scrollTo(0, 0);

    const section = document.querySelector('.product-finder-section');
    if (!section) return;

    if (window.pfInitialized) return;
    window.pfInitialized = true;

    // --- IMPROVEMENT: GRAPHQL CONFIGURATION ---
    const STOREFRONT_TOKEN = section.dataset.storefrontToken || ''; 
    const GRAPHQL_ENDPOINT = '/api/2024-01/graphql.json';

    const config = {
        baseUrl: section.dataset.apiBase,
        sectionId: section.dataset.sectionId,
        storefrontToken: STOREFRONT_TOKEN,
        concurrency: STOREFRONT_TOKEN ? 5 : 3, 
        debug: true,
        cacheDuration: 60 * 60 * 1000, 
        dropdownCacheDuration: 24 * 60 * 60 * 1000 
    };

    if (!config.baseUrl) {
        console.error('Product Finder: API Base URL is missing.');
        return;
    }

    // --- IMPROVEMENT: HTML TEMPLATES ---
    const templatesHTML = `
    <template id="pf-fitment-modal-tpl">
        <div id="pf-fitment-modal" class="pf-modal-overlay">
          <div class="pf-modal-content">
            <div class="pf-modal-header">
              <h3 class="pf-modal-title">Vehicle Fitment</h3>
              <button class="pf-modal-close" type="button">&times;</button>
            </div>
            <div class="pf-modal-body" id="pf-modal-body"></div>
          </div>
        </div>
    </template>
    
    <template id="pf-card-skeleton-tpl">
        <div class="pf-result-card pf-loading">
            <div class="pf-card-image-wrapper">
                <div class="pf-img-placeholder"></div>
                <span class="pf-fit-badge-overlay pf-tpl-fit-badge"></span>
            </div>
            <div class="pf-card-info">
                <div class="pf-card-title pf-tpl-title"></div>
                <div class="pf-card-sku pf-tpl-sku"></div>
                <div class="pf-card-cats">
                    <span class="pf-tpl-cat-text"></span>
                </div>
                <div class="pf-card-meta"><span class="pf-loading-text">Waiting...</span></div>
            </div>
        </div>
    </template>
    `;
    document.body.insertAdjacentHTML('beforeend', templatesHTML);

    if (!document.getElementById('pf-fitment-modal')) {
        const modalTpl = document.getElementById('pf-fitment-modal-tpl');
        document.body.appendChild(modalTpl.content.cloneNode(true));
    }

    const els = {
        container: section.querySelector('.pf-container'),
        header: section.querySelector('.pf-header-row'),
        toggleIcon: section.querySelector('.pf-toggle-icon'),
        body: section.querySelector('.pf-body'),
        type: document.getElementById(`pf-type-${config.sectionId}`),
        year: document.getElementById(`pf-year-${config.sectionId}`),
        make: document.getElementById(`pf-make-${config.sectionId}`),
        model: document.getElementById(`pf-model-${config.sectionId}`),
        submit: document.getElementById(`pf-submit-${config.sectionId}`),
        reset: document.getElementById(`pf-reset-${config.sectionId}`),
        error: document.getElementById(`pf-error-${config.sectionId}`),
        results: document.getElementById(`pf-results-${config.sectionId}`),
        status: document.getElementById(`pf-status-${config.sectionId}`),
        filterWrapper: document.getElementById(`pf-filter-wrapper-${config.sectionId}`),
        filter: document.getElementById(`pf-filter-${config.sectionId}`),
        modal: document.getElementById('pf-fitment-modal'),
        modalBody: document.getElementById('pf-modal-body'),
        modalClose: document.querySelector('.pf-modal-close')
    };

    let state = { type: '', year: '', make: '', model: '', allModels: [] };
    const skuCache = new Map();
    const STORAGE_KEY = 'pf_my_garage';
    const RESULTS_CACHE_KEY = 'pf_garage_results';
    const DROPDOWN_CACHE_PREFIX = 'pf_dd_';

    const placeholderSvg = `
        <div class="pf-img-placeholder no-img">
            <svg class="pf-placeholder-svg" viewBox="0 0 24 24" width="48" height="48" fill="none" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" style="color: #bbb; opacity: 0.7;">
              <circle cx="12" cy="12" r="3"></circle>
              <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"></path>
            </svg>
            <span class="pf-placeholder-text" style="font-size:0.8rem; margin-top:8px; font-weight:600; letter-spacing:0.05em; text-transform:uppercase; color:#999;">Catalog Item</span>
        </div>
    `;

    function toggleScrollLock(locked) {
        if (locked) {
            document.body.classList.add('overflow-hidden');
            document.body.style.overflow = 'hidden';        
        } else {
            document.body.classList.remove('overflow-hidden');
            document.body.style.overflow = '';
        }
    }

    function closeModal() {
        const m = document.getElementById('pf-fitment-modal');
        if(m) {
            m.classList.remove('open');
            toggleScrollLock(false);
        }
    }

    if(els.modalClose) els.modalClose.addEventListener('click', closeModal);
    if(els.modal) els.modal.addEventListener('click', (e) => {
        if(e.target === els.modal) closeModal();
    });

    function escapeHtml(value) {
        if (value === null || value === undefined) return '';
        return value.toString()
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#039;');
    }

    // --- BROAD MATCH ENGINE ---
    // Catalog model names are inconsistent: the same machine appears as
    // "500 XT", "ALTERRA 500", "ALTERRA 500 TRV XT EPS", "500 (ALL)", etc.,
    // and each parts manufacturer publishes fitment under a different spelling.
    /**
     * The matching itself lives in fitment-match.js, shared with the results page and the product
     * page badge, so the three cannot drift into answering the same question differently. This
     * file keeps what is its own: the dropdowns, the two passes, and the cards.
     */
    const F = window.GHSFitment;

    function getSimilarModels(selectedModel, allModels) {
        const sel = F.parseModel(selectedModel);
        if (!sel.core) return [selectedModel];

        return allModels.filter(m => {
            const cand = F.parseModel(m);
            // Must have the same core displacement number
            if (cand.core !== sel.core) return false;
            // Same family when the smaller identity-token set is contained in
            // the larger one (a bare "500" is a catch-all for the 500 family)
            const small = cand.tokens.length <= sel.tokens.length ? cand.tokens : sel.tokens;
            const large = small === cand.tokens ? sel.tokens : cand.tokens;
            return small.every(t => large.includes(t));
        });
    }

    // --- FIT BADGES ---
    const ICON_CHECK = `<svg class="pf-icon-check" viewBox="0 0 24 24" width="12" height="12" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" style="display:inline-block; flex-shrink:0; vertical-align:middle; margin-right:4px;"><polyline points="20 6 9 17 4 12"></polyline></svg>`;
    const ICON_INFO = `<svg class="pf-icon-info" viewBox="0 0 24 24" width="12" height="12" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" style="display:inline-block; flex-shrink:0; vertical-align:middle; margin-right:4px;"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="16" x2="12" y2="12"></line><line x1="12" y1="8" x2="12.01" y2="8"></line></svg>`;

    const FIT_BADGES = {
        exact:   { text: 'Exact Fit',           badgeClass: 'pf-fit-exact',   cardClass: 'pf-exact-match',   icon: ICON_CHECK },
        family:  { text: 'Fits Your Machine',   badgeClass: 'pf-fit-family',  cardClass: 'pf-family-match',  icon: ICON_CHECK },
        similar: { text: 'Check Fitment', badgeClass: 'pf-fit-similar', cardClass: 'pf-similar-match', icon: ICON_INFO }
    };

    function getFitBadge(matchType) {
        return FIT_BADGES[matchType] || FIT_BADGES.similar;
    }

    /**
     * The badge for one result. A part established for only some trims of the machine keeps the
     * "check this" styling and trades the generic wording for the trims themselves - a shopper
     * can check a name against their own machine, and cannot check "Check Fitment" against
     * anything.
     */
    function fitBadgeFor(item) {
        const fit = getFitBadge(item && item.matchType);
        if (!item || !item.trimNote) return fit;
        return {
            text: item.trimNote,
            badgeClass: FIT_BADGES.similar.badgeClass,
            cardClass: FIT_BADGES.similar.cardClass,
            icon: FIT_BADGES.similar.icon
        };
    }

    function buildFitBadge(fit) {
        return `<span class="pf-fit-badge-overlay ${fit.badgeClass}">${fit.icon}<span>${fit.text}</span></span>`;
    }

    // Does a fitment record (make/model/years) cover the currently selected machine?
    function machineMatchesSelection(record) {
        if (!state.make || !state.model || !state.year) return false;
        if (String(record.fitmentMake || '').toUpperCase().trim() !== state.make.toUpperCase().trim()) return false;

        const years = String(record.fitmentYears || '').match(/\d{4}/g);
        if (!years || !years.length) return false;
        const y = parseInt(state.year, 10);
        const nums = years.map(Number);
        const yearOk = nums.length === 1 ? nums[0] === y : (y >= Math.min(...nums) && y <= Math.max(...nums));
        if (!yearOk) return false;

        const tier = F.classifyMatch(state.model, String(record.fitmentModel || ''));
        return tier === 'exact' || tier === 'family';
    }

    async function openFitmentModal(sku, title) {
        const m = document.getElementById('pf-fitment-modal');
        const mBody = document.getElementById('pf-modal-body');
        const mTitle = m.querySelector('.pf-modal-title');
        
        const existingFooter = m.querySelector('.pf-modal-footer');
        if(existingFooter) existingFooter.remove();

        mBody.innerHTML = '<div class="pf-modal-loading">Loading fitment data...</div>';
        mTitle.textContent = title || 'Vehicle Fitment';
        
        m.classList.add('open');
        toggleScrollLock(true); 

        try {
            const data = await fetchData('/item/getFitmentMachines', { itemNumber: sku }, true);
            
            if(data && data.fitments && data.fitments.length > 0) {
                data.fitments.sort((a, b) => {
                    if(a.fitmentMake !== b.fitmentMake) return a.fitmentMake.localeCompare(b.fitmentMake);
                    if(a.fitmentModel !== b.fitmentModel) return a.fitmentModel.localeCompare(b.fitmentModel);
                    return b.fitmentYears.localeCompare(a.fitmentYears, undefined, {numeric: true});
                });

                let anyMatch = false;
                let rows = '';
                data.fitments.forEach(fmt => {
                    const hit = machineMatchesSelection(fmt);
                    if (hit) anyMatch = true;
                    rows += `<tr${hit ? ' class="pf-fitment-row-match"' : ''}><td>${escapeHtml(fmt.fitmentMake)}</td><td>${escapeHtml(fmt.fitmentModel)}</td><td>${escapeHtml(fmt.fitmentYears)}</td></tr>`;
                });

                let html = '';
                if (state.make && state.model && state.year) {
                    const vehicle = escapeHtml(`${state.year} ${state.make} ${state.model}`);
                    html += anyMatch
                        ? `<div class="pf-fitment-your-match">${ICON_CHECK}This part's fitment list covers your ${vehicle} (highlighted below)</div>`
                        : `<div class="pf-fitment-no-match">${ICON_INFO}Your ${vehicle} is not explicitly listed below - contact us and we'll confirm fitment for you</div>`;
                }
                html += '<table class="pf-fitment-table"><thead><tr><th>Make</th><th>Model</th><th>Year(s)</th></tr></thead><tbody>' + rows + '</tbody></table>';
                mBody.innerHTML = html;
            } else {
                mBody.innerHTML = '<div class="pf-modal-loading">No specific machine fitment data returned.</div>';
            }
        } catch(e) {
            mBody.innerHTML = '<div class="pf-error">Error loading fitment data.</div>';
        }
    }

    // --- IMPROVEMENT: SECTION RENDERING API ---
    async function refreshCartDrawer() {
        try {
            const cartRes = await fetch(window.Shopify.routes.root + 'cart.js');
            const cartData = await cartRes.json();
            
            const badgeSelectors = '.cart-count-bubble, .cart-count, [data-cart-count], .header__cart-count, .header-cart__count';
            document.querySelectorAll(badgeSelectors).forEach(el => {
                el.textContent = cartData.item_count;
                el.classList.remove('hidden');
                el.style.display = 'block'; 
            });
        } catch (e) {}

        try {
            // Fetch only the Cart section via Shopify Section Rendering API
            const targetSection = 'cart-drawer'; // Ensure this matches your theme's cart drawer ID
            const sectionUrl = `${window.Shopify.routes.root}?sections=${targetSection}`;
            const pageRes = await fetch(sectionUrl);
            const sectionData = await pageRes.json();
            
            if (sectionData[targetSection]) {
                const currentDrawer = document.getElementById(`shopify-section-${targetSection}`) || document.getElementById(targetSection) || document.querySelector('.cart-drawer-container');
                if (currentDrawer) {
                    const parsedHtml = new DOMParser().parseFromString(sectionData[targetSection], 'text/html');
                    currentDrawer.innerHTML = parsedHtml.querySelector('.shopify-section, body').innerHTML;
                }
            }
        } catch (e) { console.error("Drawer rendering failed", e); }
    }

    async function openSpecsModal(sku, title, variantId, available, inventoryQty, inventoryPolicy, inventoryManagement) {
        const m = document.getElementById('pf-fitment-modal');
        const mBody = document.getElementById('pf-modal-body');
        
        const existingFooter = m.querySelector('.pf-modal-footer');
        if(existingFooter) existingFooter.remove();

        const mTitle = m.querySelector('.pf-modal-title');
        
        mBody.innerHTML = '<div class="pf-modal-loading">Fetching technical specifications...</div>';
        mTitle.textContent = title ? `Specs: ${title}` : 'Product Specifications';
        
        m.classList.add('open');
        toggleScrollLock(true); 

        try {
            const [detailsData, inventoryData] = await Promise.all([
                fetchData('/item/getDetail', { itemNumber: sku }, true),
                fetchData('/inventory', { partNumber: sku }, false)
            ]);
            
            if(detailsData && detailsData.details) {
                const specs = detailsData.details.techSpecs;
                const desc = detailsData.details.extendedDescription;
                const img = detailsData.details.imgRef;
                
                let html = '<div class="pf-specs-content">';
                
                if(img) {
                    const imgSrc = img.startsWith('/') ? `https://www.gammasales.com/images${img}` : img;
                     html += `<div style="text-align:center; margin-bottom:20px;"><img src="${escapeHtml(imgSrc)}" style="max-height:200px; width:auto;"></div>`;
                }

                if (specs) { html += `<h4>Technical Specifications</h4><div>${specs}</div>`; }
                if (desc) { html += `<h4 style="margin-top:15px;">Description</h4><div>${desc}</div>`; }
                if (!specs && !desc) { html += '<p>No specific technical data available for this item.</p>'; }
                
                html += '</div>';
                mBody.innerHTML = html;

                if (variantId && variantId !== "undefined" && variantId !== "null") {
                    const footer = document.createElement('div');
                    footer.className = 'pf-modal-footer';
                    
                    const isAvailable = available === 'true';
                    let maxQty = 999;
                    let stockText = "";
                    
                    let liveQty = 0;
                    if (inventoryData && inventoryData.inventoryLevel) {
                        liveQty = parseInt(inventoryData.inventoryLevel.quantity) || 0;
                    } else {
                        liveQty = parseInt(inventoryQty) || 0;
                    }

                    if (isAvailable) {
                        if (liveQty > 0) {
                            stockText = `${liveQty} in Stock`;
                        } else {
                            stockText = "In Stock"; 
                        }
                    }

                    if (inventoryManagement === 'shopify' && inventoryPolicy === 'deny') {
                        maxQty = liveQty > 0 ? liveQty : 1; 
                    }

                    let innerHTML = '';
                    
                    if (isAvailable) {
                        innerHTML = `
                        <div class="pf-qty-wrapper">
                            <div class="pf-qty-row">
                                <label class="pf-qty-label" for="pf-modal-qty">Qty:</label>
                                <input type="number" id="pf-modal-qty" class="pf-qty-input" value="1" min="1" max="${maxQty}">
                            </div>
                            <div class="pf-stock-info">${stockText}</div>
                        </div>
                        <button type="button" class="pf-btn-modal-atc">Add to Cart</button>`;
                    } else {
                        innerHTML = `<button type="button" class="pf-btn-modal-atc" disabled>Out of Stock</button>`;
                    }
                    
                    footer.innerHTML = innerHTML;
                    m.querySelector('.pf-modal-content').appendChild(footer);

                    const atcBtn = footer.querySelector('.pf-btn-modal-atc');

                    if(atcBtn && isAvailable) {
                        const qtyInput = footer.querySelector('#pf-modal-qty');
                        if(qtyInput) {
                            qtyInput.addEventListener('change', function() {
                                let val = parseInt(this.value);
                                if(val < 1) this.value = 1;
                                if(val > maxQty) this.value = maxQty;
                            });
                        }

                        atcBtn.addEventListener('click', async () => {
                            const finalQtyInput = document.getElementById('pf-modal-qty');
                            let qtyToAdd = 1;
                            if (finalQtyInput) {
                                qtyToAdd = parseInt(finalQtyInput.value);
                                if (isNaN(qtyToAdd) || qtyToAdd < 1) qtyToAdd = 1;
                            }

                            atcBtn.disabled = true;
                            atcBtn.textContent = 'Adding...';
                            
                            try {
                                const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
                                    method: 'POST',
                                    headers: { 'Content-Type': 'application/json' },
                                    body: JSON.stringify({ items: [{ id: parseInt(variantId), quantity: qtyToAdd }] })
                                });
                                
                                if(response.ok) {
                                    atcBtn.classList.add('success');
                                    atcBtn.textContent = 'Added!';
                                    
                                    await refreshCartDrawer();

                                    setTimeout(() => {
                                        atcBtn.disabled = false;
                                        atcBtn.classList.remove('success');
                                        atcBtn.textContent = 'Add to Cart';
                                    }, 3000);

                                } else {
                                    throw new Error('Failed to add');
                                }
                            } catch(err) {
                                atcBtn.disabled = false;
                                atcBtn.textContent = 'Add to Cart';
                                const msg = document.createElement('span');
                                msg.className = 'pf-modal-error-msg';
                                msg.textContent = 'Error adding item.';
                                if(!footer.querySelector('.pf-modal-error-msg')) footer.insertBefore(msg, footer.firstChild);
                            }
                        });
                    }
                }

            } else {
                mBody.innerHTML = '<div class="pf-modal-loading">No details found for this item.</div>';
            }
        } catch(e) {
            mBody.innerHTML = '<div class="pf-error">Error loading specifications.</div>';
        }
    }
    
    // --- GLOBAL CLICK LISTENER ---
    document.addEventListener('click', function(e) {
        const specsBtn = e.target.closest('.pf-specs-btn');
        if(specsBtn) {
            e.preventDefault();
            e.stopPropagation();
            
            const sku = specsBtn.dataset.sku;
            const title = specsBtn.dataset.title;
            const variantId = specsBtn.dataset.variantId;
            const available = specsBtn.dataset.available;
            const invQty = specsBtn.dataset.inventoryQty;
            const invPolicy = specsBtn.dataset.inventoryPolicy;
            const invMgmt = specsBtn.dataset.inventoryManagement;
            
            openSpecsModal(sku, title, variantId, available, invQty, invPolicy, invMgmt);
            return;
        }

        const fitBtn = e.target.closest('.pf-fitment-btn');
        if(fitBtn) {
            e.preventDefault();
            e.stopPropagation();
            const sku = fitBtn.dataset.sku;
            const title = fitBtn.dataset.title;
            openFitmentModal(sku, title);
            return;
        }

        const contactBtn = e.target.closest('.pf-btn-contact');
        if(contactBtn) {
            e.stopPropagation();
            return; 
        }

        const card = e.target.closest('.pf-result-card');
        if(card && !fitBtn && !contactBtn && !specsBtn) {
            const url = card.dataset.href;
            if (url) {
                window.location.href = url;
            }
        }
    });

    let isExpanded = false;
    if(els.header) {
        els.header.addEventListener('click', () => toggleSection(!isExpanded));
    }

    function toggleSection(open) {
        isExpanded = open;
        if (open) {
            els.body.style.display = 'block';
            els.body.style.maxHeight = els.body.scrollHeight + "px";
            section.classList.add('pf-open');
            section.classList.remove('pf-closed');
            // Once expanded, release the clipping so combobox panels can
            // overflow the collapsible body (overflow:hidden is only needed
            // while the max-height animation runs)
            setTimeout(() => {
                if (isExpanded) {
                    els.body.style.maxHeight = 'none';
                    els.body.style.overflow = 'visible';
                }
            }, 300);
        } else {
            els.body.style.overflow = 'hidden';
            els.body.style.maxHeight = els.body.scrollHeight + "px";
            void els.body.offsetHeight;
            els.body.style.maxHeight = '0px';
            setTimeout(() => { if(!isExpanded) els.body.style.display = 'none'; }, 300);
            section.classList.remove('pf-open');
            section.classList.add('pf-closed');
        }
    }
    toggleSection(false);

    /**
     * Fills the model box, one entry per machine.
     *
     * The catalogue spells a machine many ways - a 2019 Polaris ATV came to 208 entries, half of
     * them trims of a machine already in the list. Those are folded under the plain name, which
     * covers them all, and the list drops to about a hundred.
     *
     * They are folded, not dropped: the option stays in the select, marked with the trim it
     * carries, and typing that trim brings it back (see makeSearchableSelect). So a shopper who
     * knows they own the SP still picks the SP exactly, and one who does not is not asked.
     */
    function processAndPopulateModels(rawModelsList) {
        const sortedModels = [...rawModelsList].sort();
        const bases = machineGroups[String(state.make || '').toUpperCase()] || {};
        const inList = new Set(sortedModels);
        const foldedUnder = {};
        Object.keys(bases).forEach(function (base) {
            if (!inList.has(base)) return;
            bases[base].forEach(function (member) {
                if (member !== base && inList.has(member)) foldedUnder[member] = base;
            });
        });

        els.model.innerHTML = '<option value="">Select Model</option>';
        sortedModels.forEach(modelName => {
            const option = document.createElement('option');
            option.value = modelName;
            option.textContent = modelName;
            const base = foldedUnder[modelName];
            if (base) {
                option.dataset.pfTrim = F.readableTrim(F.trimAgainst(base, modelName));
                option.dataset.pfBase = base;
            }
            els.model.appendChild(option);
        });
        els.model.disabled = false;
    }

    function getDropdownCache(key) {
        const item = localStorage.getItem(DROPDOWN_CACHE_PREFIX + key);
        if (!item) return null;
        try {
            const parsed = JSON.parse(item);
            if (Date.now() - parsed.ts > config.dropdownCacheDuration) {
                localStorage.removeItem(DROPDOWN_CACHE_PREFIX + key);
                return null;
            }
            return parsed.data;
        } catch (e) { return null; }
    }

    function setDropdownCache(key, data) {
        try {
            localStorage.setItem(DROPDOWN_CACHE_PREFIX + key, JSON.stringify({
                ts: Date.now(),
                data: data
            }));
        } catch (e) { }
    }

    async function fetchData(endpoint, params = {}, useCache = false) {
        const queryString = new URLSearchParams(params).toString();
        const cacheKey = `${endpoint}?${queryString}`;
        if (useCache) {
            const cached = getDropdownCache(cacheKey);
            if (cached) return cached;
        }
        const url = new URL(`${config.baseUrl}${endpoint}`);
        Object.keys(params).forEach(key => {
            if(params[key]) url.searchParams.append(key, params[key]);
        });
        try {
            const response = await fetch(url, {
                headers: { 'Content-Type': 'application/json' }
            });
            if (!response.ok) throw new Error(`API Error: ${response.status}`);
            const json = await response.json();
            if (useCache && json.data) { setDropdownCache(cacheKey, json.data); }
            return json.data;
        } catch (err) { return null; }
    }

    async function fetchArrivalDate(sku) {
        if(!sku) return null;
        try {
            const data = await fetchData('/inventory/getEstimatedArrivalsForItem', { partNumber: sku }, false);
            if (data && data.arrivalDates && Array.isArray(data.arrivalDates) && data.arrivalDates.length > 0) {
                const sorted = data.arrivalDates.sort((a, b) => new Date(a.eta) - new Date(b.eta));
                const nextArrival = sorted[0];
                const dateObj = new Date(nextArrival.eta);
                const dateStr = dateObj.toLocaleDateString(undefined, { month: 'short', day: 'numeric', year: 'numeric' });
                return {
                    date: dateStr,
                    type: nextArrival.etaType === 'CARGO' ? 'Confirmed' : 'Est.',
                    qty: nextArrival.qty
                };
            }
        } catch (e) {}
        return null;
    }

    async function fetchGammaProductDetails(sku) {
        if (!sku) return null;
        try {
            const data = await fetchData('/item/getDetail', { itemNumber: sku }, true);
            if (data && data.details) {
                return data;
            }
        } catch (e) {}
        return null;
    }

    function delay(ms) { return new Promise(resolve => setTimeout(resolve, ms)); }

    /* ------------------------------------------- catalogue details, only when seen -------- */

    /**
     * Arrival dates and catalogue details are fetched for a card when it scrolls into view, not
     * for every result at once.
     *
     * They come from Gamma, which allows a burst of about 100 calls and then roughly one a
     * second, shared by everyone on the site at once. A search used to ask once per out-of-stock
     * part and twice per part the store does not list, so a machine with a few hundred results
     * spent the whole allowance on cards nobody had scrolled to, and every card past the
     * hundredth said "No date" for the wrong reason. Two at a time, only for what is on screen,
     * keeps one search inside the allowance and leaves room for the next shopper.
     */
    const LAZY_AT_ONCE = 2;
    const lazyQueue = [];
    let lazyActive = 0;
    let lazyObserver = null;

    /** The arrival-date line of a card. Pending while the card waits its turn to ask. */
    function etaRow(arrivalData, pending) {
        let label = 'Arrival date:';
        let value = pending ? 'checking...' : 'No date';
        if (arrivalData) {
            value = arrivalData.date;
            label = arrivalData.type === 'Confirmed' ? 'Arrival date confirmed :' : 'Arrival date Estimated :';
        }
        return `<div class="pf-eta-info"><span class="pf-eta-label">${label}</span><span class="pf-eta-date">${escapeHtml(value)}</span></div>`;
    }

    /** Flags a card as having something left to fetch: dates for a listed part, details too for an unlisted one. */
    function markLazy(card, sku, listed) {
        card.dataset.pfLazy = listed ? 'dates' : 'details';
        card.dataset.pfSku = sku;
    }

    function watchLazyCards() {
        const cards = els.results.querySelectorAll('[data-pf-lazy]');
        if (!('IntersectionObserver' in window)) { cards.forEach(enqueueLazy); return; }
        if (!lazyObserver) {
            lazyObserver = new IntersectionObserver(function (entries) {
                entries.forEach(function (entry) {
                    if (!entry.isIntersecting) return;
                    lazyObserver.unobserve(entry.target);
                    enqueueLazy(entry.target);
                });
            }, { rootMargin: '300px 0px' });
        }
        cards.forEach(function (card) { lazyObserver.observe(card); });
    }

    function enqueueLazy(card) {
        if (!card.dataset.pfLazy) return;
        lazyQueue.push({ card: card, what: card.dataset.pfLazy, sku: card.dataset.pfSku });
        delete card.dataset.pfLazy;
        pumpLazy();
    }

    function pumpLazy() {
        while (lazyActive < LAZY_AT_ONCE && lazyQueue.length) {
            const job = lazyQueue.shift();
            lazyActive++;
            fillLazyCard(job).catch(function () {}).then(function () { lazyActive--; pumpLazy(); });
        }
    }

    async function fillLazyCard(job) {
        // A card that a new search has already replaced is not worth a call.
        if (!job.card.isConnected) return;
        const wantDetails = job.what === 'details';
        const [arrival, details] = await Promise.all([
            fetchArrivalDate(job.sku),
            wantDetails ? fetchGammaProductDetails(job.sku) : Promise.resolve(null)
        ]);
        if (!job.card.isConnected) return;
        const eta = job.card.querySelector('.pf-eta-info');
        if (eta) eta.outerHTML = etaRow(arrival, false);
        if (!details || !details.details) return;

        let img = details.details.imgRef || '';
        if (img.startsWith('/')) img = 'https://www.gammasales.com/images' + img;
        const wrap = job.card.querySelector('.pf-card-image-wrapper');
        if (img && wrap && !wrap.querySelector('img')) {
            const badge = wrap.querySelector('.pf-fit-badge-overlay');
            const title = job.card.querySelector('.pf-card-title');
            wrap.innerHTML = `<img src="${escapeHtml(img)}" alt="${escapeHtml(title ? title.textContent : '')}" loading="lazy" referrerpolicy="no-referrer" onerror="this.style.display='none';this.nextElementSibling.style.display='flex';">` +
                placeholderSvg.replace('class="pf-img-placeholder no-img"', 'class="pf-img-placeholder no-img" style="display:none;"') +
                (badge ? badge.outerHTML : '');
        }
        const msrp = details.pricing && details.pricing.msrp;
        const meta = job.card.querySelector('.pf-card-meta > div');
        if (msrp && meta && !meta.querySelector('.pf-price-container')) {
            meta.insertAdjacentHTML('afterbegin', `<div class="pf-price-container" style="margin-bottom:8px; font-weight:bold; color:#333;"><span class="pf-price-label">MSRP:</span> <span class="pf-price">$${Number(msrp).toFixed(2)}</span></div>`);
        }
    }

    // --- IMPROVEMENT: GRAPHQL SKU BATCHING ---
    async function fetchShopifyProductsBatchGraphQL(skus) {
        if (!STOREFRONT_TOKEN || STOREFRONT_TOKEN.trim() === '') {
            console.warn("GraphQL Token missing. Falling back to individual AJAX.");
            return false;
        }

        // Shopify returns at most 50 products per query, so batch the SKUs
        const CHUNK_SIZE = 40;
        let anySucceeded = false;

        for (let start = 0; start < skus.length; start += CHUNK_SIZE) {
            const chunk = skus.slice(start, start + CHUNK_SIZE);
            const skuQuery = chunk.map(sku => `sku:${String(sku).replace(/"/g, '')}`).join(' OR ');
            const query = `
            {
              products(first: 50, query: "${skuQuery}") {
                edges {
                  node {
                    id
                    title
                    handle
                    variants(first: 10) {
                      edges {
                        node {
                          id
                          sku
                          price { amount }
                          availableForSale
                          image { url }
                          quantityAvailable
                        }
                      }
                    }
                  }
                }
              }
            }`;

            try {
                const response = await fetch(GRAPHQL_ENDPOINT, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'X-Shopify-Storefront-Access-Token': STOREFRONT_TOKEN
                    },
                    body: JSON.stringify({ query })
                });

                if (response.ok) {
                    const json = await response.json();
                    const products = json.data?.products?.edges || [];

                    products.forEach(({node: product}) => {
                        product.variants.edges.forEach(({node: variant}) => {
                            if (variant.sku) {
                                const cleanSku = String(variant.sku).trim().toLowerCase();
                                const mappedResult = {
                                    product: {
                                        title: product.title,
                                        handle: product.handle,
                                        featured_image: variant.image?.url
                                    },
                                    variant: {
                                        id: variant.id.split('/').pop(),
                                        sku: variant.sku,
                                        price: parseFloat(variant.price.amount) * 100,
                                        available: variant.availableForSale,
                                        inventory_quantity: variant.quantityAvailable
                                    }
                                };
                                skuCache.set(cleanSku, mappedResult);
                            }
                        });
                    });
                    anySucceeded = true;
                }
            } catch (e) { console.error("GraphQL failed:", e); }
        }
        return anySucceeded;
    }

    async function searchShopifyProduct(sku, retryCount = 0) {
        const cleanSku = sku ? sku.toString().trim() : '';
        if (!cleanSku) return null;
        // Cache keys are always lowercased (the GraphQL pre-warm stores them that way)
        const cacheKey = cleanSku.toLowerCase();
        if (skuCache.has(cacheKey) && skuCache.get(cacheKey) !== null) return skuCache.get(cacheKey);
        let productHandle = null;
        try {
            const safeSku = cleanSku.replace(/"/g, '');
            const encodedSkuQuery = encodeURIComponent(`variants.sku:"${safeSku}"`);
            const suggestUrl = `/search/suggest.json?q=${encodedSkuQuery}&resources[type]=product&resources[limit]=1&resources[options][unavailable_products]=show&resources[fields]=handle&_t=${Date.now()}`;
            const suggestResponse = await fetch(suggestUrl);
            if (suggestResponse.status === 429 || suggestResponse.status >= 500) {
                if (retryCount < 3) {
                    const waitTime = 1000 * Math.pow(2, retryCount);
                    await delay(waitTime);
                    return searchShopifyProduct(sku, retryCount + 1);
                }
                return null;
            }
            if (suggestResponse.ok) {
                const json = await suggestResponse.json();
                if (json.resources?.results?.products?.length > 0) productHandle = json.resources.results.products[0].handle;
            }
        } catch (error) {
            if (retryCount < 1) { await delay(1000); return searchShopifyProduct(sku, retryCount + 1); }
        }
        if (productHandle) {
            try {
                const productResponse = await fetch(`/products/${productHandle}.js`);
                if (productResponse.status === 429 || productResponse.status >= 500) {
                    if (retryCount < 3) {
                        await delay(1000);
                        return searchShopifyProduct(sku, retryCount + 1);
                    }
                }
                if (productResponse.ok) {
                    const data = await productResponse.json();
                    const variant = data.variants.find(v => v.sku && String(v.sku).trim().toLowerCase() === cacheKey) || data.variants[0];
                    const result = { product: data, variant: variant };
                    skuCache.set(cacheKey, result);
                    return result;
                }
            } catch (e) {}
        }
        skuCache.set(cacheKey, null);
        return null;
    }

    /* ------------------------------------------------------- the machine dropdowns ---- */

    /**
     * Where the four dropdowns come from.
     *
     * They used to be four calls to the catalogue, one per dropdown, each waiting on an API with
     * a quota bucket of 100 that refills slowly - so picking a machine meant four round trips
     * before a shopper had asked for anything. They now come out of fitment-machines.json, a file
     * the theme already ships for shop-by-machine, built from the same fitment data the metafields
     * are built from. One download, cached by the browser, and every dropdown after it is instant.
     *
     * The file is a tree: vehicle type -> make -> model -> year ranges. Only types the catalogue
     * publishes a model year for are offered, because this selector asks for the year second and
     * a type with no years would dead-end. Outdoor equipment is not sold by year and is browsed
     * through shop-by-machine instead, which has no year step.
     *
     * It is 535 KB gzipped, so it is fetched on first contact with the section rather than on page
     * load - pointing at or tabbing into the section starts it well before a shopper reaches the
     * first dropdown.
     */
    const MACHINE_INDEX_URL = section.dataset.machinesUrl || '';
    let machineIndex = null;
    let machineGroups = {};
    /**
     * Makes whose machines a person has named (Syncshop's data/machines/). Their products carry
     * the name itself in fitment.machine, so one search finds every spelling of the machine.
     */
    let curatedMakes = [];
    /**
     * The machines Gamma spells differently from the way this file names them - see `catalog` in
     * Syncshop's fitment-filter.ts. Read only when the catalogue is asked for parts.
     */
    let machineCatalog = {};
    let machineIndexPromise = null;

    /**
     * What to call a machine when asking Gamma's catalogue for parts.
     *
     * Every name in the machine file has its punctuation folded away, so that three catalogues
     * disagreeing about a hyphen still describe one machine. Gamma's own API does not fold, and
     * says so only by answering with nothing: SKANDIC SWT 600 E-TEC has 55 parts, SKANDIC SWT 600
     * E TEC has none. So the folded name is turned back into the spellings Gamma files the
     * machine under, and each is asked for - at most four, and one for all but 358 machines.
     *
     * A machine Gamma has no spelling for is asked for by the name the shopper picked, which is
     * what happened before this existed: the plain names of a machine are Kimpex's and the
     * curated lists', and Gamma has nothing filed under them either way.
     */
    function catalogNames(make, model) {
        const forMake = machineCatalog[String(make || '').toUpperCase()];
        const spellings = forMake && forMake[model];
        return spellings && spellings.length ? spellings : [model];
    }

    /**
     * The badge for a part filed for only some versions of the machine they picked.
     *
     * The versions themselves come from fitment-match.js, which the results page reads too; only
     * the wording is here, because the two pages have room for different amounts of it.
     */
    function trimNoteFor(base, members, matched, picked) {
        const names = F.matchedTrims(base, members, matched, picked);
        return names ? 'Fits ' + F.trimList(names) + ' only - check your trim' : null;
    }

    /**
     * Offers the plain machine name - SPORTSMAN 850 - beside the 31 trim spellings Gamma files
     * parts under, carrying the years of every trim below it.
     *
     * The model dropdown otherwise asks which trim they own before it will do anything, and most
     * people do not know: it is a badge on a brochure, not something they think about. The same
     * plain names are offered by shop-by-machine, out of the same list in fitment-machines.json,
     * so the two ways into the store agree on what counts as one machine.
     *
     * A part found under only some of the trims is still shown - the badge names which, in
     * trimNoteFor below.
     */
    function addPlainNames() {
        Object.keys(machineIndex).forEach(function (type) {
            const makes = machineIndex[type];
            Object.keys(makes).forEach(function (make) {
                const bases = machineGroups[make];
                if (!bases) return;
                const models = makes[make];
                Object.keys(bases).forEach(function (base) {
                    let ranges = [];
                    let known = 0;
                    bases[base].forEach(function (member) {
                        if (models[member]) {
                            known++;
                            ranges = ranges.concat(models[member]);
                        }
                    });
                    // A base whose spellings all sit under a different vehicle type belongs to
                    // that type, not this one.
                    if (known) models[base] = F.mergeRanges(ranges);
                });
            });
        });
    }

    /**
     * The machine a chosen model belongs to, whether they picked the plain name or one trim of it.
     *
     * Both need it, for different reasons. Picking the plain name searches every spelling under it.
     * Picking one trim searches them too - it always has - and the answer for a part filed under a
     * different trim used to be "Check Fitment", which tells a shopper nothing they can act on.
     * Knowing the machine lets that part say which trim it IS filed for, so they can compare it
     * with the one they own.
     */
    function machineOf(make, model) {
        const bases = machineGroups[String(make || '').toUpperCase()];
        if (!bases) return null;
        if (bases[model]) return { base: model, members: bases[model], pickedTrim: false };
        const names = Object.keys(bases);
        for (let i = 0; i < names.length; i++) {
            if (bases[names[i]].indexOf(model) !== -1) {
                return { base: names[i], members: bases[names[i]], pickedTrim: true };
            }
        }
        return null;
    }

    function ensureMachineIndex() {
        if (machineIndexPromise) return machineIndexPromise;
        machineIndexPromise = fetch(MACHINE_INDEX_URL)
            .then(function (r) {
                if (!r.ok) throw new Error('machine list unavailable');
                return r.json();
            })
            .then(function (data) {
                machineIndex = data && data.types ? data.types : null;
                if (!machineIndex) throw new Error('machine list is not the expected shape');
                machineGroups = (data && data.groups) || {};
                curatedMakes = (data && data.curated) || [];
                machineCatalog = (data && data.catalog) || {};
                addPlainNames();
                return machineIndex;
            })
            .catch(function (e) {
                console.error('Product Finder: ' + e.message);
                // Let the next attempt try again rather than leaving the page permanently broken.
                machineIndexPromise = null;
                return null;
            });
        return machineIndexPromise;
    }

    /** Does a machine's published year ranges cover this year? */
    function rangesCoverYear(ranges, year) {
        for (let i = 0; i < ranges.length; i++) {
            if (year >= ranges[i][0] && year <= ranges[i][1]) return true;
        }
        return false;
    }

    /**
     * The types worth offering: the catalogue publishes a model year for them, so the year step
     * below has something to ask. Machines it publishes no type for sit under an empty key and
     * are skipped here - they are real, and shop-by-machine is where they are reached.
     */
    function typeOptions() {
        const out = [];
        Object.keys(machineIndex).forEach(function (type) {
            if (!type) return;
            const makes = machineIndex[type];
            const hasYears = Object.keys(makes).some(function (make) {
                return Object.keys(makes[make]).some(function (model) { return makes[make][model].length > 0; });
            });
            if (hasYears) out.push(type);
        });
        return out.sort();
    }

    /** Newest year first, the way the catalogue used to hand them over. */
    function yearOptions(type) {
        const makes = machineIndex[type] || {};
        const years = new Set();
        Object.keys(makes).forEach(function (make) {
            const models = makes[make];
            Object.keys(models).forEach(function (model) {
                models[model].forEach(function (r) {
                    for (let y = r[0]; y <= r[1]; y++) years.add(y);
                });
            });
        });
        return [...years].sort(function (a, b) { return b - a; }).map(String);
    }

    function makeOptions(type, year) {
        const makes = machineIndex[type] || {};
        const y = parseInt(year, 10);
        return Object.keys(makes).filter(function (make) {
            const models = makes[make];
            return Object.keys(models).some(function (model) { return rangesCoverYear(models[model], y); });
        }).sort();
    }

    function modelOptions(type, year, make) {
        const models = (machineIndex[type] || {})[make] || {};
        const y = parseInt(year, 10);
        return Object.keys(models).filter(function (model) { return rangesCoverYear(models[model], y); }).sort();
    }

    /**
     * Fills one dropdown from the machine list, showing why it is empty if the list is still on
     * its way or never arrived. Returns what it filled, so the caller can hold on to the models.
     */
    async function fillFromIndex(el, level, defaultText) {
        setSelectLoading(el);
        if (!machineIndex && !(await ensureMachineIndex())) {
            resetSelect(el, defaultText);
            showError('Could not load the machine list. Please refresh and try again.');
            return [];
        }
        const values = level();
        populateSelect(el, values, defaultText);
        return values;
    }

    /* -------------------------------------------------- fitment metafields -------- */

    /**
     * Where the parts list comes from.
     *
     * Every product carries a product metafield, fitment.machine, holding the machines it fits
     * as "MAKE MODEL" strings, and Shopify can filter on it natively. Asking Shopify is free and
     * instant, where asking the catalogue costs one call per model out of a quota bucket of 100
     * that refills slowly - so a busy afternoon used to throttle real shoppers.
     *
     * That metafield deliberately carries no year: a list metafield holds 128 entries and
     * make+model+year came to 2.2 million keys. So the year is settled here instead, against
     * fitment.machines - the per-variant JSON holding the real year ranges, the same data the
     * product page's compatibility table is drawn from. Without that second pass, filtering on
     * the machine alone would offer a 2015 Ranger owner parts that only fit 2019-2024, which is
     * exactly the overstatement this store does not make.
     *
     * The catalogue is still asked for the exact model, and only so that parts the store does not
     * list yet still appear as "Not available yet" with a contact link. It used to be asked once
     * per similar model on top of that; the metafield covers those now. Once per search for all
     * but the 358 machines Gamma files under more than one spelling - see catalogNames.
     */
    const FITMENT_NAMESPACE = 'fitment';
    const MACHINE_KEY = 'machine';
    const MACHINES_KEY = 'machines';
    /** Storefront connections cap at 250; no single machine comes near a second page. */
    const SEARCH_PAGE_SIZE = 250;
    const SEARCH_MAX_PAGES = 4;

    function machineLabel(make, model) {
        return (make + ' ' + model).toUpperCase().replace(/\s+/g, ' ').trim();
    }

    const MACHINE_SEARCH_QUERY = [
        'query($filters: [ProductFilter!], $after: String) {',
        '  search(query: "*", types: PRODUCT, first: ' + SEARCH_PAGE_SIZE + ', after: $after, productFilters: $filters) {',
        '    pageInfo { hasNextPage endCursor }',
        '    edges { node { ... on Product {',
        '      title handle productType',
        '      featuredImage { url }',
        '      variants(first: 10) { edges { node {',
        '        id sku availableForSale quantityAvailable',
        '        price { amount }',
        '        image { url }',
        '        metafield(namespace: "' + FITMENT_NAMESPACE + '", key: "' + MACHINES_KEY + '") { value }',
        '      } } }',
        '    } } }',
        '  }',
        '}'
    ].join('\n');

    /**
     * Every product Shopify holds for one machine, with the fitment JSON needed to judge the year.
     * Returns an empty list rather than throwing: a machine that cannot be searched must not empty
     * the page, because the catalogue pass still has an answer for it.
     */
    async function fetchProductsForMachine(label) {
        if (!STOREFRONT_TOKEN || STOREFRONT_TOKEN.trim() === '') return [];

        const filters = [{ productMetafield: { namespace: FITMENT_NAMESPACE, key: MACHINE_KEY, value: label } }];

        /**
         * Tried twice before being given up on. Giving up returns an empty list, which quietly
         * makes the results shorter rather than showing an error - so one dropped call has to be
         * rare, not merely survivable. A single retry is what makes it rare.
         */
        async function askShopify(after) {
            for (let attempt = 0; attempt < 2; attempt++) {
                try {
                    const response = await fetch(GRAPHQL_ENDPOINT, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            'X-Shopify-Storefront-Access-Token': STOREFRONT_TOKEN
                        },
                        body: JSON.stringify({ query: MACHINE_SEARCH_QUERY, variables: { after: after, filters: filters } })
                    });
                    if (response.ok) {
                        const json = await response.json();
                        if (json.data && json.data.search) return json.data.search;
                    }
                } catch (e) { /* falls through to the retry, then to giving up */ }
                if (attempt === 0) await delay(400);
            }
            console.error('Fitment search gave up on ' + label);
            return null;
        }

        const out = [];
        let after = null;
        for (let page = 0; page < SEARCH_MAX_PAGES; page++) {
            const search = await askShopify(after);
            if (!search) break;

            (search.edges || []).forEach(function (edge) {
                const product = edge.node;
                const variants = ((product.variants && product.variants.edges) || []).map(function (e) { return e.node; });
                // The machine sits on the product, so it can belong to a sibling variant. The year
                // is judged against every variant's fitment rather than whichever came first.
                const fitmentJson = variants.map(function (v) { return v.metafield && v.metafield.value; }).filter(Boolean);

                variants.forEach(function (variant) {
                    if (!variant.sku) return;
                    out.push({
                        sku: String(variant.sku).trim(),
                        title: product.title,
                        handle: product.handle,
                        productType: product.productType || '',
                        image: (variant.image && variant.image.url) || (product.featuredImage && product.featuredImage.url) || null,
                        variantId: variant.id.split('/').pop(),
                        price: parseFloat(variant.price.amount) * 100,
                        available: variant.availableForSale,
                        quantity: variant.quantityAvailable,
                        fitmentJson: fitmentJson
                    });
                });
            });

            if (!search.pageInfo || !search.pageInfo.hasNextPage) break;
            after = search.pageInfo.endCursor;
        }
        return out;
    }

    /**
     * Puts a Storefront result into the shape the card renderer already reads, and pre-warms the
     * SKU cache so the availability pass finds it without a second round trip.
     */
    function adoptStorefrontProduct(p, matchType) {
        skuCache.set(p.sku.toLowerCase(), {
            product: { title: p.title, handle: p.handle, featured_image: p.image },
            variant: {
                id: p.variantId,
                sku: p.sku,
                price: p.price,
                available: p.available,
                inventory_quantity: p.quantity
            }
        });
        return {
            itemNumber: p.sku,
            description: p.title,
            subCategory: p.productType,
            matchType: matchType
        };
    }

    function showError(msg) {
        els.error.textContent = msg;
        els.error.classList.remove('hidden');
        toggleSection(true); 
    }
    
    function clearError() { 
        els.error.textContent = ''; 
        els.error.classList.add('hidden'); 
    }
    
    function showStatus(msg) { 
        els.status.textContent = msg; 
        els.status.classList.remove('hidden'); 
    }
    
    function hideStatus() { 
        els.status.classList.add('hidden'); 
    }
    
    function removeBanner() {
        const existingBanner = document.getElementById('pf-broad-match-banner');
        if (existingBanner) existingBanner.remove();
    }

    function resetSelect(el, txt) { el.innerHTML = `<option value="">${txt}</option>`; el.disabled = true; }
    
    function populateSelect(el, opts, defaultText) {
        el.innerHTML = `<option value="">${defaultText}</option>`;
        opts.forEach(o => { const op = document.createElement('option'); op.value = o; op.textContent = o; el.appendChild(op); });
        el.disabled = false;
    }
    
    function setSelectLoading(el) { el.innerHTML = `<option>Loading...</option>`; el.disabled = true; }

    function sortProducts(products) {
        // REVERTED to original sorting: By Category, then Description.
        return products.sort((a, b) => {
            const catA = (a.subCategory || '').toString().trim();
            const catB = (b.subCategory || '').toString().trim();
            const catCmp = catA.localeCompare(catB, undefined, { sensitivity: 'base' });
            if (catCmp !== 0) return catCmp;
            const descA = (a.description || a.title || '').toString().trim();
            const descB = (b.description || b.title || '').toString().trim();
            return descA.localeCompare(descB, undefined, { sensitivity: 'base' });
        });
    }

    function saveGarageSelection() {
        try {
            const vehicleData = {
                type: els.type.value,
                year: els.year.value,
                make: els.make.value,
                model: els.model.value
            };
            localStorage.setItem(STORAGE_KEY, JSON.stringify(vehicleData));
        } catch (e) {}
    }

    function saveGarageResults(products) {
        try {
            const validProducts = products.filter(item => item !== null && item !== undefined);
            const cacheData = { timestamp: Date.now(), products: validProducts };
            localStorage.setItem(RESULTS_CACHE_KEY, JSON.stringify(cacheData));
        } catch (e) {}
    }

    async function loadFromGarage() {
        const storedSelection = localStorage.getItem(STORAGE_KEY);
        if (!storedSelection) return false;
        try {
            const vehicle = JSON.parse(storedSelection);
            if (!vehicle.type || !vehicle.year || !vehicle.make || !vehicle.model) return false;
            els.type.value = vehicle.type; state.type = vehicle.type;

            populateSelect(els.year, yearOptions(state.type), 'Select Year');
            els.year.value = vehicle.year; state.year = vehicle.year;

            populateSelect(els.make, makeOptions(state.type, state.year), 'Select Make');
            els.make.value = vehicle.make; state.make = vehicle.make;

            state.allModels = modelOptions(state.type, state.year, state.make);
            processAndPopulateModels(state.allModels);
            els.model.value = vehicle.model;
            state.model = vehicle.model;
            els.submit.disabled = false;

            const cachedResults = localStorage.getItem(RESULTS_CACHE_KEY);
            if (cachedResults) {
                const cache = JSON.parse(cachedResults);
                const age = Date.now() - cache.timestamp;
                if (age < config.cacheDuration && Array.isArray(cache.products) && cache.products.length > 0) {
                    const sortedCached = sortProducts(cache.products);
                    setupFilter(sortedCached);
                    renderCachedCards(sortedCached);
                    watchLazyCards();
                    return true;
                }
            }
            return true;
        } catch (e) { return false; }
    }

    async function init() {
        let started = false;
        const start = async function () {
            if (started) return;
            started = true;
            const types = await fillFromIndex(els.type, typeOptions, 'Select Type');
            if (types.length) await loadFromGarage();
        };

        /**
         * The machine list is fetched on first contact with the section, not on page load. The
         * section starts collapsed, so opening it is already a pointer down on the section, and
         * pointing at or tabbing into it starts the fetch earlier still - either way it is well
         * before a shopper reaches the first dropdown.
         */
        ['pointerenter', 'pointerdown', 'touchstart', 'focusin'].forEach(function (evt) {
            section.addEventListener(evt, start, { once: true, passive: true });
        });

        // A shopper with a machine already saved gets it back without having to touch anything.
        if (localStorage.getItem(STORAGE_KEY)) await start();
    }

    els.type.addEventListener('change', function() {
        state.type = this.value; resetDownstream('type');
        if(!state.type) return;
        populateSelect(els.year, yearOptions(state.type), 'Select Year');
    });

    els.year.addEventListener('change', function() {
        state.year = this.value; resetDownstream('year');
        if(!state.year) return;
        populateSelect(els.make, makeOptions(state.type, state.year), 'Select Make');
    });

    els.make.addEventListener('change', function() {
        state.make = this.value; resetDownstream('make');
        if(!state.make) return;
        state.allModels = modelOptions(state.type, state.year, state.make);
        processAndPopulateModels(state.allModels);
    });

    els.model.addEventListener('change', function() {
        state.model = this.value;
        els.submit.disabled = !state.model;
    });

    function resetDownstream(level) {
        if (level === 'type') { resetSelect(els.year, 'Select Year'); resetSelect(els.make, 'Select Make'); resetSelect(els.model, 'Select Model'); }
        else if (level === 'year') { resetSelect(els.make, 'Select Make'); resetSelect(els.model, 'Select Model'); }
        else if (level === 'make') { resetSelect(els.model, 'Select Model'); }
        els.submit.disabled = true;
        els.results.innerHTML = '';
        els.results.classList.add('hidden');
        els.filterWrapper.classList.add('hidden');
        removeBanner();
        localStorage.removeItem(RESULTS_CACHE_KEY);
        state.allModels = [];
    }

    els.reset.addEventListener('click', function() {
        els.type.value = "";
        state = { type: '', year: '', make: '', model: '', allModels: [] };
        resetDownstream('type');
        localStorage.removeItem(STORAGE_KEY); 
        localStorage.removeItem(RESULTS_CACHE_KEY);
    });

    els.submit.addEventListener('click', async function() {
        saveGarageSelection();
        els.results.innerHTML = '';
        els.results.classList.add('hidden');
        els.filterWrapper.classList.add('hidden');
        removeBanner();
        hideStatus();
        clearError();
        showStatus('Finding parts that fit...');
        els.submit.disabled = true; els.reset.disabled = true;

        const selectedModel = els.model.value;
        /**
         * A plain machine name stands for every spelling under it, so all of them are searched.
         * getSimilarModels already reaches most of them, but only the group says which spellings
         * ARE the machine - the rest it finds are neighbours, and stay labelled as such.
         */
        const machine = machineOf(state.make, selectedModel);
        const members = machine && machine.members;
        /**
         * A curated make is searched once, by the machine's name: its products carry that name
         * rather than the spellings (a Sportsman 850 used to cost 140 searches and 18 seconds).
         * The year check and the trim badge still read the spellings out of each variant's
         * fitment.machines, so nothing about what is shown or claimed changes - only the asking.
         */
        const curated = curatedMakes.indexOf(String(state.make || '').toUpperCase()) !== -1;
        const similar = curated ? [] : getSimilarModels(selectedModel, state.allModels || []);
        const modelsToSearch = curated
            ? [machine ? machine.base : selectedModel]
            : members
                ? members.concat(similar.filter(function (m) { return members.indexOf(m) === -1; }))
                : similar;

        const bySku = new Map();
        const MATCH_RANK = { exact: 3, family: 2, similar: 1 };
        // Counted by part, not by sighting: the same part comes back from several of the model
        // names searched below, and a part the catalogue pass restores is not hidden at all.
        const hiddenSkus = new Set();

        // Highest-confidence occurrence of a part wins, whichever pass found it.
        const keep = item => {
            const sku = item.itemNumber ? item.itemNumber.toString().trim() : '';
            if (!sku) return;
            const prev = bySku.get(sku);
            if (!prev || (MATCH_RANK[item.matchType] || 0) > (MATCH_RANK[prev.matchType] || 0)) bySku.set(sku, item);
        };

        try {
            /**
             * Pass one: what the store actually sells for this machine, straight out of Shopify.
             * The exact model is searched first, then the sibling names the same machine is
             * published under. These are Shopify calls, so the extra models cost nothing but time.
             */
            const searchBatch = 4;
            for (let i = 0; i < modelsToSearch.length; i += searchBatch) {
                const batch = modelsToSearch.slice(i, i + searchBatch);
                const results = await Promise.all(batch.map(m => fetchProductsForMachine(machineLabel(state.make, m))));
                results.forEach(products => {
                    products.forEach(p => {
                        const year = F.yearVerdict(p.fitmentJson, state.make, selectedModel, state.year, members, { requireYear: true });
                        if (year.verdict === 'wrong-year') { hiddenSkus.add(p.sku); return; }
                        // Dropped without a word: a part for an Alterra 450 is not a part for
                        // their 500, and counting it in the year note would misname why it went.
                        if (year.verdict === 'other-machine') return;
                        // A part whose own fitment names this machine and this year is a confirmed
                        // fit however the search reached it; anything softer keeps the softer word.
                        const matchType = year.verdict === 'check' || year.verdict === 'trim' ? 'similar' : year.tier;
                        const item = adoptStorefrontProduct(p, matchType);
                        // Shown either way; the note is what keeps showing it honest.
                        item.trimNote = machine
                            ? trimNoteFor(machine.base, members, year.matched, selectedModel)
                            : null;
                        keep(item);
                    });
                });
            }

            /**
             * Pass two: the catalogue, for the exact model only, under the spellings Gamma itself
             * files it under. It is asked for two things the metafield cannot give - parts the
             * store does not list yet, which become the "Not available yet" cards, and cover for
             * any listed product whose fitment metafield has not been written. It is already
             * narrowed to the year, so no year check applies.
             */
            const asked = catalogNames(state.make, selectedModel);
            const catalogPages = await Promise.all(asked.map(function (name) {
                return fetchData('/fitment/getFitmentProducts', { make: state.make, year: state.year, model: name }, true);
            }));
            catalogPages.forEach(function (exactData) {
                if (exactData && exactData.fitmentProducts) {
                    exactData.fitmentProducts.forEach(p => keep({ ...p, matchType: 'exact' }));
                }
            });
        } catch (e) { console.error("Error building fitment results:", e); }

        const uniqueItems = Array.from(bySku.values());
        // Only read when nothing was found, to say why: parts exist for this machine, just not
        // for this year. A count beside a full list of results was noise.
        const hiddenWrongYear = [...hiddenSkus].filter(sku => !bySku.has(sku)).length;

        if (uniqueItems.length === 0) {
            showError(hiddenWrongYear > 0
                ? 'No parts found for this year. Parts were found for this model, but none list your year.'
                : 'No products found.');
            els.submit.disabled = false; els.reset.disabled = false;
            hideStatus();
            return;
        }

        // Reverted to original category sorting
        const sortedItems = sortProducts(uniqueItems);

        // Anything the Shopify pass supplied is already in the SKU cache; this fills in the rest.
        const skusToFetch = sortedItems.map(i => i.itemNumber).filter(sku => !skuCache.has(String(sku).trim().toLowerCase()));
        if (skusToFetch.length) await fetchShopifyProductsBatchGraphQL(skusToFetch);

        setupFilter(sortedItems);
        renderSkeletons(sortedItems);
        const finalResults = await processQueue(sortedItems);
        saveGarageResults(finalResults);

        els.submit.disabled = false; els.reset.disabled = false;
        if(!isExpanded) toggleSection(true);
    });

    function setupFilter(items) {
        const subCats = new Set(items.map(i => i.subCategory || i.gammaItem?.subCategory).filter(Boolean));
        const sorted = Array.from(subCats).sort();
        els.filter.innerHTML = '<option value="all">All Categories</option>';
        sorted.forEach(cat => { const o = document.createElement('option'); o.value = cat; o.textContent = cat; els.filter.appendChild(o); });
        els.filterWrapper.classList.remove('hidden');
    }

    els.filter.addEventListener('change', function() {
        const val = this.value;
        const cards = els.results.querySelectorAll('.pf-result-card');
        cards.forEach(c => { c.classList.toggle('hidden', val !== 'all' && c.dataset.cat !== val); });
        const dividers = els.results.querySelectorAll('.pf-category-divider');
        dividers.forEach(d => { d.classList.toggle('hidden', val !== 'all'); });
    });

    function renderSkeletons(items) {
        els.results.classList.remove('hidden');
        let lastCat = null;
        const skeletonTpl = document.getElementById('pf-card-skeleton-tpl');

        items.forEach((item, idx) => {
            const currentCat = (item.subCategory || 'Other Parts').toString();
            if (currentCat !== lastCat) {
                const div = document.createElement('div');
                div.className = 'pf-category-divider';
                div.textContent = currentCat;
                els.results.appendChild(div);
                lastCat = currentCat;
            }

            const clone = skeletonTpl.content.cloneNode(true);
            const card = clone.querySelector('.pf-result-card');
            card.id = `pf-card-idx-${idx}`; 
            card.dataset.cat = item.subCategory; 
            
            card.querySelector('.pf-tpl-title').textContent = item.description || 'Loading...';
            card.querySelector('.pf-tpl-sku').textContent = `Part #: ${item.itemNumber}`;
            card.querySelector('.pf-tpl-cat-text').textContent = item.subCategory || '';
            
            // Apply inline match badge
            const badgeEl = card.querySelector('.pf-tpl-fit-badge');
            const fit = fitBadgeFor(item);
            badgeEl.className = 'pf-fit-badge-overlay ' + fit.badgeClass;
            badgeEl.innerHTML = `${fit.icon}<span>${fit.text}</span>`;
            card.classList.add(fit.cardClass);

            els.results.appendChild(clone);
        });
    }

    function renderCachedCards(cachedItems) {
        els.results.classList.remove('hidden');
        let lastCat = null;
        
        cachedItems.forEach((item, idx) => {
            if (!item) return;

            const currentCat = (item.subCategory || 'Other Parts').toString();
            if (currentCat !== lastCat) {
                const div = document.createElement('div');
                div.className = 'pf-category-divider';
                div.textContent = currentCat;
                els.results.appendChild(div);
                lastCat = currentCat;
            }
            
            const card = document.createElement('div');
            card.id = `pf-card-idx-${idx}`; 
            
            const safeTitle = escapeHtml(item.title);
            const safeSku = escapeHtml(item.sku);
            const safeCat = escapeHtml(item.subCategory || '');

            const fitmentBtn = `<button class="pf-fitment-btn" type="button" data-sku="${safeSku}" data-title="${safeTitle}">Fitment</button>`;

            const specsBtn = `<button class="pf-specs-btn" type="button"
                data-sku="${safeSku}"
                data-title="${safeTitle}"
                data-variant-id="${item.variantId || ''}"
                data-available="${item.available}"
                data-inventory-qty="${item.inventoryQty || 0}"
                data-inventory-policy="${item.inventoryPolicy || ''}"
                data-inventory-management="${item.inventoryManagement || ''}">
                Specs</button>`;
            
            const actionRow = `<div class="pf-action-row">${specsBtn}${fitmentBtn}</div>`;

            // Badge HTML
            const fit = fitBadgeFor(item);
            const fitBadgeHtml = buildFitBadge(fit);
            const cardClass = fit.cardClass;

            if (item.found) {
                card.className = `pf-result-card pf-match ${cardClass}`;
                card.dataset.href = item.url;
                card.dataset.cat = item.subCategory;
                const cls = item.available ? 'pf-in-stock' : 'pf-out-stock';
                const txt = item.available ? 'In Stock' : 'Out of Stock';
                const price = `<span class="pf-price">$${(item.price/100).toFixed(2)}</span>`;
                
                let etaHtml = '';
                if (!item.available) {
                   etaHtml = etaRow(item.arrivalData, !item.arrivalData);
                   if (!item.arrivalData) markLazy(card, item.sku, true);
                }
                
                card.innerHTML = `
                    <div class="pf-card-image-wrapper">
                        <img src="${escapeHtml(item.image)}" alt="${safeTitle}" loading="lazy">
                        ${fitBadgeHtml}
                    </div>
                    <div class="pf-card-info">
                        <div class="pf-card-title">${safeTitle}</div>
                        <div class="pf-card-sku">Part #: ${safeSku}</div>
                        <div class="pf-card-cats">${safeCat}</div>
                        <div class="pf-card-meta">
                             <div style="display:flex; justify-content:space-between; align-items:center; width:100%;">${price}<span class="pf-badge ${cls}">${txt}</span></div>
                             ${etaHtml}
                             ${actionRow}
                        </div>
                    </div>`;
            } else {
                card.className = `pf-result-card pf-no-match ${cardClass}`;
                card.dataset.cat = item.subCategory;
                
                let imgContent = placeholderSvg;
                if(item.gammaImage) {
                    imgContent = `<img src="${escapeHtml(item.gammaImage)}" alt="${safeTitle}" loading="lazy" referrerpolicy="no-referrer" onerror="this.style.display='none';this.nextElementSibling.style.display='flex';">` +
                                  placeholderSvg.replace('class="pf-img-placeholder no-img"', 'class="pf-img-placeholder no-img" style="display:none;"');
                }
                
                let priceHtml = '';
                if (item.msrp) {
                    priceHtml = `<div class="pf-price-container" style="margin-bottom:8px; font-weight:bold; color:#333;"><span class="pf-price-label">MSRP:</span> <span class="pf-price">$${item.msrp.toFixed(2)}</span></div>`;
                }
                
                const mailSubject = encodeURIComponent(`Inquiry: ${item.title} (Part #${item.sku})`);
                const contactBtn = `<a href="mailto:info@garageharrystanley.com?subject=${mailSubject}" class="pf-btn-contact">Contact to Reserve</a>`;
                
                const etaHtml = etaRow(item.arrivalData, !item.arrivalData);
                if (!item.arrivalData || !item.gammaImage) markLazy(card, item.sku, false);

                card.innerHTML = `
                    <div class="pf-card-image-wrapper">
                        ${imgContent}
                        ${fitBadgeHtml}
                    </div>
                    <div class="pf-card-info">
                        <div class="pf-card-title">${safeTitle}</div>
                        <div class="pf-card-sku">Part #: ${safeSku}</div>
                        <div class="pf-card-cats">${safeCat}</div>
                        <div class="pf-card-meta">
                            <div style="width:100%;">
                                ${priceHtml}
                                <span class="pf-badge pf-special-order" style="width:100%; text-align:center; margin-bottom:8px;">Not available yet</span>
                                ${contactBtn}
                                ${etaHtml}
                                ${actionRow}
                            </div>
                        </div>
                    </div>`;
            }
            els.results.appendChild(card);
        });
    }

    async function processQueue(items) {
        await delay(100);
        let completed = 0; let qIdx = 0;
        const updateStatus = () => showStatus(`Checking availability... ${completed} / ${items.length}`);
        updateStatus();
        const resultsToCache = new Array(items.length);
        const worker = async () => {
            while(qIdx < items.length) {
                const i = qIdx++; const item = items[i];
                const card = document.getElementById(`pf-card-idx-${i}`);
                if(card) card.querySelector('.pf-loading-text').textContent = 'Checking...';
                
                const res = await searchShopifyProduct(item.itemNumber);
                // Arrival dates and catalogue details are left for the card to fetch when it
                // is scrolled to - see fillLazyCard.
                const cachedItem = updateCard(i, item, res, null, null);
                resultsToCache[i] = cachedItem;
                completed++;
                if(completed % 5 === 0) updateStatus();
            }
        };
        const workers = [];
        for(let i=0; i<config.concurrency; i++) workers.push(worker());
        await Promise.all(workers);
        watchLazyCards();
        showStatus(`Done. ${completed} processed.`);
        setTimeout(hideStatus, 4000);
        return resultsToCache;
    }

    function updateCard(idx, gammaItem, data, arrivalData, gammaDetails) {
        const card = document.getElementById(`pf-card-idx-${idx}`);
        if(!card) return null;
        card.classList.remove('pf-loading');
        const imgWrap = card.querySelector('.pf-card-image-wrapper');
        const titleEl = card.querySelector('.pf-card-title');
        const metaEl = card.querySelector('.pf-card-meta');
        const catsEl = card.querySelector('.pf-card-cats');
        
        const cacheObj = { 
            sku: gammaItem.itemNumber, 
            subCategory: gammaItem.subCategory, 
            matchType: gammaItem.matchType, // Carry match type to Cache
            trimNote: gammaItem.trimNote,   // and the trim note, so the card reads the same
            found: false, 
            title: gammaItem.description,
            gammaImage: null,
            msrp: null
        };

        // Inject Badge into Image wrapper instead of Category row
        const fit = fitBadgeFor(cacheObj);
        const fitBadgeHtml = buildFitBadge(fit);
        card.classList.add(fit.cardClass);

        if (catsEl) {
            catsEl.textContent = cacheObj.subCategory || '';
        }

        if(data && data.product && data.variant) {
            cacheObj.found = true;
            cacheObj.title = data.product.title;
            cacheObj.url = `/products/${data.product.handle}?variant=${data.variant.id}`;
            cacheObj.image = data.variant.featured_image?.src || data.product.featured_image || 'https://cdn.shopify.com/s/files/1/0533/2089/files/placeholder-images-image_large.png';
            cacheObj.price = data.variant.price;
            cacheObj.available = data.variant.available;
            cacheObj.variantId = data.variant.id; 
            cacheObj.inventoryQty = data.variant.inventory_quantity; 
            cacheObj.inventoryPolicy = data.variant.inventory_policy; 
            cacheObj.inventoryManagement = data.variant.inventory_management; 
            cacheObj.arrivalData = arrivalData;
            
            card.classList.add('pf-match');
            card.dataset.href = cacheObj.url;

            imgWrap.innerHTML = `<img src="${escapeHtml(cacheObj.image)}" alt="${escapeHtml(cacheObj.title)}" loading="lazy">${fitBadgeHtml}`;
            titleEl.textContent = cacheObj.title;
            
            const cls = cacheObj.available ? 'pf-in-stock' : 'pf-out-stock';
            const txt = cacheObj.available ? 'In Stock' : 'Out of Stock';
            const priceHtml = `<span class="pf-price">$${(cacheObj.price/100).toFixed(2)}</span>`;
            
            let etaHtml = '';
            if (!cacheObj.available) {
               etaHtml = etaRow(arrivalData, !arrivalData);
               if (!arrivalData) markLazy(card, cacheObj.sku, true);
            }

            const shopifyFitmentBtn = `<button class="pf-fitment-btn" type="button" data-sku="${escapeHtml(cacheObj.sku)}" data-title="${escapeHtml(cacheObj.title)}">Fitment</button>`;
            const shopifySpecsBtn = `<button class="pf-specs-btn" type="button"
                data-sku="${escapeHtml(cacheObj.sku)}"
                data-title="${escapeHtml(cacheObj.title)}"
                data-variant-id="${data.variant.id}"
                data-available="${cacheObj.available}"
                data-inventory-qty="${cacheObj.inventoryQty}"
                data-inventory-policy="${cacheObj.inventoryPolicy}"
                data-inventory-management="${cacheObj.inventoryManagement}">Specs</button>`;
            const shopifyActionRow = `<div class="pf-action-row">${shopifySpecsBtn}${shopifyFitmentBtn}</div>`;

            metaEl.innerHTML = `<div style="display:flex; justify-content:space-between; align-items:center; width:100%;">${priceHtml}<span class="pf-badge ${cls}">${txt}</span></div>${etaHtml}${shopifyActionRow}`;
        } 
        else {
            cacheObj.found = false;
            if (gammaDetails && gammaDetails.details && gammaDetails.details.imgRef) {
                cacheObj.gammaImage = gammaDetails.details.imgRef;
            }
            
            if (gammaDetails && gammaDetails.pricing && gammaDetails.pricing.msrp) {
                cacheObj.msrp = gammaDetails.pricing.msrp;
            }

            card.classList.add('pf-no-match');
            
            let imgContent = placeholderSvg;
            if (cacheObj.gammaImage) {
                 if(cacheObj.gammaImage.startsWith('/')) {
                     cacheObj.gammaImage = 'https://www.gammasales.com/images' + cacheObj.gammaImage;
                 }

                 imgContent = `<img src="${escapeHtml(cacheObj.gammaImage)}" alt="${escapeHtml(cacheObj.title)}" loading="lazy" referrerpolicy="no-referrer" onerror="this.style.display='none';this.nextElementSibling.style.display='flex';">` +
                               placeholderSvg.replace('class="pf-img-placeholder no-img"', 'class="pf-img-placeholder no-img" style="display:none;"');
            }
            imgWrap.innerHTML = imgContent + fitBadgeHtml;
            
            titleEl.textContent = cacheObj.title || 'Unknown Part';
            titleEl.style.color = '#333'; 

            let priceHtml = '';
            if (cacheObj.msrp) {
                priceHtml = `<div class="pf-price-container" style="margin-bottom:8px; font-weight:bold; color:#333;"><span class="pf-price-label">MSRP:</span> <span class="pf-price">$${cacheObj.msrp.toFixed(2)}</span></div>`;
            }

            const mailSubject = encodeURIComponent(`Inquiry: ${cacheObj.title} (Part #${cacheObj.sku})`);
            const contactBtn = `<a href="mailto:info@garageharrystanley.com?subject=${mailSubject}" class="pf-btn-contact">Contact to Reserve</a>`;
            
            const etaHtml = etaRow(arrivalData, !arrivalData);
            if (!arrivalData || !gammaDetails) markLazy(card, cacheObj.sku, false);

            const fitmentBtn = `<button class="pf-fitment-btn" type="button" data-sku="${escapeHtml(cacheObj.sku)}" data-title="${escapeHtml(cacheObj.title)}">Fitment</button>`;
            const specsBtn = `<button class="pf-specs-btn" type="button" data-sku="${escapeHtml(cacheObj.sku)}" data-title="${escapeHtml(cacheObj.title)}">Specs</button>`;
            const actionRow = `<div class="pf-action-row">${specsBtn}${fitmentBtn}</div>`;

            metaEl.innerHTML = `
                <div style="width:100%;">
                    ${priceHtml}
                    <span class="pf-badge pf-special-order" style="width:100%; text-align:center; margin-bottom:8px;">Not available yet</span>
                    ${contactBtn}
                    ${etaHtml}
                    ${actionRow}
                </div>`;
        }
        return cacheObj;
    }

    // --- SEARCHABLE DROPDOWNS ---
    // Year/Make/Model lists can be very long (the catalog lists every model-name
    // variant), so those native selects are enhanced into type-to-filter
    // comboboxes. The native <select> stays as the source of truth: committing a
    // choice sets select.value and fires 'change', so all existing logic
    // (cascading resets, garage restore, submit enablement) is untouched.
    function makeSearchableSelect(selectEl) {
        if (!selectEl || selectEl.dataset.pfCombo) return;
        selectEl.dataset.pfCombo = '1';
        selectEl.classList.add('pf-combo-native');

        const wrap = document.createElement('div');
        wrap.className = 'pf-combo';
        const input = document.createElement('input');
        input.type = 'text';
        input.className = 'pf-select pf-combo-input';
        input.autocomplete = 'off';
        input.setAttribute('autocapitalize', 'off');
        input.setAttribute('spellcheck', 'false');
        input.setAttribute('role', 'combobox');
        input.setAttribute('aria-expanded', 'false');
        const panel = document.createElement('div');
        panel.className = 'pf-combo-panel hidden';
        panel.setAttribute('role', 'listbox');
        wrap.appendChild(input);
        wrap.appendChild(panel);
        selectEl.parentNode.insertBefore(wrap, selectEl);

        let isOpen = false;

        const optionList = () => Array.from(selectEl.options).slice(1); // skip placeholder
        const selectedText = () => (selectEl.selectedIndex > 0 ? selectEl.options[selectEl.selectedIndex].textContent : '');

        function renderPanel(filter) {
            const f = (filter || '').trim().toUpperCase();
            const opts = optionList().filter(function (o) {
                // A trim folded under a plain name waits until the shopper types the trim: with
                // nothing typed the list shows machines, not every spelling of them.
                const trim = o.dataset.pfTrim;
                if (trim !== undefined) {
                    if (!f) return false;
                    // The trim itself ("SP"), or a search that has gone past the machine name and
                    // is plainly after one version of it ("SPORTSMAN 850 SP").
                    return (
                        trim.toUpperCase().includes(f) ||
                        (!o.dataset.pfBase.toUpperCase().includes(f) && o.textContent.toUpperCase().includes(f))
                    );
                }
                return !f || o.textContent.toUpperCase().includes(f);
            });
            if (!opts.length) {
                panel.innerHTML = '<div class="pf-combo-empty">No matches</div>';
                return;
            }
            panel.innerHTML = opts.map(o =>
                `<div class="pf-combo-item${o.value === selectEl.value && selectEl.selectedIndex > 0 ? ' is-selected' : ''}" role="option" data-value="${escapeHtml(o.value)}">${escapeHtml(o.textContent)}</div>`
            ).join('');
        }

        function openPanel(filter) {
            if (selectEl.disabled) return;
            isOpen = true;
            panel.classList.remove('hidden');
            input.setAttribute('aria-expanded', 'true');
            renderPanel(filter);
        }

        function closePanel() {
            isOpen = false;
            panel.classList.add('hidden');
            input.setAttribute('aria-expanded', 'false');
        }

        function sync() {
            input.placeholder = selectEl.options.length ? selectEl.options[0].textContent : '';
            input.value = selectedText();
            input.disabled = selectEl.disabled;
            if (selectEl.disabled) closePanel();
        }

        function commit(value) {
            selectEl.value = value;
            closePanel();
            sync();
            selectEl.dispatchEvent(new Event('change', { bubbles: true }));
        }

        input.addEventListener('focus', function() {
            input.select();
            openPanel('');
        });
        input.addEventListener('input', function() {
            openPanel(input.value);
        });
        input.addEventListener('keydown', function(e) {
            if (e.key === 'Escape') { closePanel(); sync(); input.blur(); return; }
            if (!isOpen && (e.key === 'ArrowDown' || e.key === 'Enter')) { e.preventDefault(); openPanel(''); return; }
            const items = panel.querySelectorAll('.pf-combo-item');
            if (!items.length) return;
            const active = panel.querySelector('.pf-combo-item.is-active');
            let idx = Array.prototype.indexOf.call(items, active);
            if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
                e.preventDefault();
                idx = e.key === 'ArrowDown' ? Math.min(idx + 1, items.length - 1) : Math.max(idx - 1, 0);
                items.forEach(i => i.classList.remove('is-active'));
                items[idx].classList.add('is-active');
                items[idx].scrollIntoView({ block: 'nearest' });
            } else if (e.key === 'Enter') {
                e.preventDefault();
                const pick = active || (items.length === 1 ? items[0] : null);
                if (pick) commit(pick.dataset.value);
            }
        });
        panel.addEventListener('mousedown', function(e) {
            const item = e.target.closest('.pf-combo-item');
            if (item) { e.preventDefault(); commit(item.dataset.value); }
        });
        document.addEventListener('click', function(e) {
            if (isOpen && !wrap.contains(e.target)) { closePanel(); sync(); }
        });
        input.addEventListener('blur', function() {
            setTimeout(function() { if (!isOpen) sync(); }, 150);
        });

        // Reflect programmatic repopulation and enable/disable into the widget
        new MutationObserver(sync).observe(selectEl, { childList: true, attributes: true, attributeFilter: ['disabled'] });
        sync();
    }

    makeSearchableSelect(els.year);
    makeSearchableSelect(els.make);
    makeSearchableSelect(els.model);

    init();
});